import "cruzo/ui-components/vars.css";
import "./css/colors.css";
import "./css/font.css";
import "./css/common.css";
import "./css/typography.css";
import "cruzo/ui-components/margin.css";
import "./css/fx.css";
import "./css/icons.css";
import "./css/container.css";
import "./css/animation.css";

import "cruzo/ui-components/button.css";
import "cruzo/ui-components/checkbox.css";
import "cruzo/ui-components/input.css";
import "cruzo/ui-components/modal.css";
import "cruzo/ui-components/select.css";
import "cruzo/ui-components/spinner.css";
import "cruzo/ui-components/button-group.css";

import { Template, componentsRegistryService, routerService } from "cruzo";

import "site/components/header/header.component";
import "site/components/profile/profile.component";
import "site/components/subscription-manage/subscription-manage.component";
import "site/components/payment-status/payment-status.component";
import "site/icons/plus";
import "site/components/grammar-rule-modal/grammar-rule-modal.component";
import "site/components/proofread-prompt-modal/proofread-prompt-modal.component";

import "site/urls";
import { kickoffAuthSessionBootstrap } from "site/services/auth-session.service";

async function initApp() {
  routerService.setHashMode(true);

  Template.setAppVariables({});
  kickoffAuthSessionBootstrap();
  componentsRegistryService.initApp();
  routerService.update();
}

void initApp();
